const updates = [
  {
    date: '今日 18:32',
    title: '《我独自升级》第二季 第 12 话更新',
    desc: '成振宇觉醒暗影君主之力，地下城终极BOSS战一触即发！暗影军团全员出击，精彩不容错过。',
    tag: '韩漫',
  },
  {
    date: '今日 15:10',
    title: '《剑道第一仙》第 203 话更新',
    desc: '苏奕持剑独闯九重天，昔日废柴今朝剑道第一人，一剑破万法，九重天上无人能挡。',
    tag: '国漫',
  },
  {
    date: '今日 12:45',
    title: '《咒术回战》第 258 话更新',
    desc: '虎杖与伏黑的联动技大爆发，宿傩的领域展开被破解？咒术界最强之战进入白热化。',
    tag: '日漫',
  },
  {
    date: '昨日 22:18',
    title: '《某天成为公主》第 98 话更新',
    desc: '希娅终于揭开身世之谜，宫廷权谋的真相令人震惊，父王的态度出现微妙转变。',
    tag: '韩漫',
  },
  {
    date: '昨日 19:50',
    title: '《全职高手》番外篇 第 7 话更新',
    desc: '叶修的新战术震惊全场，君莫笑的千机伞变换出从未见过的形态，荣耀联盟都沸腾了。',
    tag: '国漫',
  },
  {
    date: '昨日 16:22',
    title: '《鬼灭之刃》柱训练篇 最终话更新',
    desc: '九柱集结完成最终特训！炭治郎领悟日之呼吸的终极奥义，无限城决战即将开启。',
    tag: '日漫',
  },
  {
    date: '前日 20:05',
    title: '《SSS级猎人》第 56 话更新',
    desc: '金闵秀获得SSS级隐藏职业，双职业的逆天组合让整个猎人协会都为之震动。',
    tag: '韩漫',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最近更新</h2>
            <p className="text-foreground-500 text-sm mt-2">实时追踪最新话更新，精彩不等待</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="space-y-0">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-0 cursor-pointer hover:bg-background-50/80 transition-colors rounded-lg px-3 -mx-3 group"
            >
              <div className="shrink-0 w-16 pt-0.5">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
              </div>
              <div className="w-1.5 h-1.5 rounded-full bg-primary-400 mt-1.5 shrink-0"></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-100/70 text-primary-700 shrink-0">{item.tag}</span>
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
              <div className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}